import React from 'react';
import { Box, Typography } from '@mui/material';

// Page section heading with the emoji + underline rule used across pages.
const SectionTitle = ({ emoji, children }) => (
  <Box sx={{ mb: 3, borderBottom: '2px solid', borderColor: 'divider', pb: 1 }}>
    <Typography variant="h5" component="h2" fontWeight="bold">
      {emoji && <Box component="span" sx={{ mr: 1 }}>{emoji}</Box>}
      {children}
    </Typography>
  </Box>
);

export default SectionTitle;
